import { render, staticRenderFns } from "./EditarPpag.vue?vue&type=template&id=d4584474&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./EditarPpag.vue?vue&type=style&index=0&id=d4584474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4584474",
  null
  
)

export default component.exports